module.exports = __webpack_public_path__ + "static/img/statistics_1.ebd6c0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/statistics_1.png
// module id = m4Qf
// module chunks = 1